import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'

// Vue.use(InfiniteLoading, {
//   slots: {
//     noMore: ''
//   }
// })

import gallery from './data/gallery.json'
// const api = '/site/ktima48/src/js/data/gallery.json';
const api = '/en/gallery/ajax';

export default {
  components: {
    InfiniteLoading
  },
  props: {
    firstgallery: {
      type: Array,
      required: true,
      default: false
    }
  },
  data() {
    return {
      page: 2,
      gallery: this.firstgallery,
      show_load_more: true
    }
  },
  methods: {
    infiniteHandler($state) {
      axios.get(api, {
        params: {
          page: this.page,
        },
      }).then(({
        data
      }) => {
        if (this.page<=data.last_page) {
          this.page += 1;
          this.gallery.push(...data.data);
          $state.loaded();
        } else {
          this.show_load_more = false;
          $state.complete();
        }
      });
    },
  }
}